<script lang="ts" setup>
import { ref, onMounted } from "vue";

export interface SliderConfig {
  filterCol: DataColumn;
  min: number;
  max: number;
  range?: number[];
}
let config!: SliderConfig;

onMounted(() => {
  config.range = [config.min, config.max];
});
</script>
<template>
  <v-range-slider
    v-model="config.range"
    :min="config.min"
    :max="config.max"
    thumb-label="always"
    :label="'' + config.min"
    @change="$emit('change')"
  >
    <template v-slot:append>
      {{ config.max }}
    </template>
  </v-range-slider>
</template>
<style scoped>
.rangeDiv {
  padding-top: 50px;
  width: 100%;
}
</style>